module.exports = __webpack_public_path__ + "img/help2.a6775bf3.png";